import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './Openipos.css';
import { format, parseISO } from 'date-fns';
import { useLocalStorage } from "../../utils/useLocalStorage";
import Pagination from '../../CommonUI/Pagination/Pagination';
import MarketIPO from "../MarketIPO";
import { Vortex } from 'react-loader-spinner'
import CallTrackApi from "../../Activity_Track/CallTrackApi";

function Openipos() {
    const [data, setData] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const { BaseURL } = useContext(URLstateContext);

    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true);
        // if (groupValue === "BSE") {
        const getUrl = BaseURL + "Forthcoming";
        fetch(`${getUrl}/2/-/-/-/-/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                //console.log(getData, "getData")
                setloadingshow(false);
            })
            .catch((error) => {
            });

        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")

            })
            .catch((error) => {
            });

    }, []);

    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        const getCocode = compcode_array[1];
        window.open("/IPO/IPO-Synopsis/" + getCoCodeId + "/" + getCocode, '_blank');
    };

    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    
    CallTrackApi("Open IPO",window.location.href);

    return (
        <>
            <div class="col-12 p-0 breadcrumIPo ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/ipo">IPO</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Open IPO</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Op-loser-sc'>
                            <div className='Op-header'>
                                <h2><span>Open IPO</span></h2>
                            </div>
                            <MarketIPO optionValue="Open IPO" />

                            <div className='Op-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company</th>
                                            <th className='text-left'>Issue Type</th>
                                            <th className='text-right'>Issue Size(&#8377; in Cr.)</th>
                                            <th className='text-right'>Open Date</th>
                                            <th className='text-right'>Close Date</th>
                                            <th className='text-right'>Offer Price(&#8377;)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ lname, ISSUETYPE, IssueSize, OPENDATE, CLOSDATE, ISSUEPRICE, CO_CODE }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={routeChange} data-id={lname.replace('-',' ') + '-' + CO_CODE} tabIndex={0} >{lname}</h6> </td>
                                                    <td className="text-left">{ISSUETYPE}</td>
                                                    <td className="text-right">{IssueSize}</td>
                                                    <td className="text-right">{(OPENDATE != null) ? (format(parseISO(OPENDATE), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{(CLOSDATE != null) ? (format(parseISO(CLOSDATE), 'dd-MMM-yyyy')) : ''}</td>
                                                    <td className="text-right">{ISSUEPRICE}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }


                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default Openipos;